var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"0 15px"}},[_c('dv-scroll-board',{staticStyle:{"width":"100%","height":"235px"},attrs:{"config":_vm.dataVal,"index":false},on:{"click":_vm.tapsq}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }